export default __webpack_public_path__ + "static/media/bahamas.80e696a2.svg";